import React, { InputHTMLAttributes } from 'react';

export const Checkbox = (props: InputHTMLAttributes<HTMLInputElement>) => {
	return (
		<div className='styled-checkbox' onClick={props.onClick}>
			<input type='checkbox' className='styled-checkbox' {...props}/>
			<label aria-hidden='true' className='checkmark'></label>
		</div>
	)
}